import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../components/spinner";
import useTableScroll from "../components/useTableScroll.js";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Mensaje } from "../components/mensajes";
import axios from "axios";

const CatalogoCatProgramatica = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CATEGORIA PROGRAMATICA", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
    { label: "CÓDIGO", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idcategoriaprogramatica.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.categoriaprogramatica
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    setActivate(true);

    let campos =
      "categoriaprogramatica, trim(descripcion)  AS descripcion, idcategoriaprogramatica";
    let nomtab = "categoriaprogramatica";
    let nomid = "idefiscal";
    let condic = "substr(categoriaprogramatica,7,10) != '0000'";

    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var datos = [];
          for (let i = 0; i < response.data.length; i++) {
            datos.push({
              idcategoriaprogramatica: response.data[i].idcategoriaprogramatica,
              descripcion: response.data[i].descripcion,
              categoriaprogramatica: response.data[i].categoriaprogramatica,
            });
          }
          setRecords(datos);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarCatProgramatica = () => {
    var idcategoriaprogramatica = values[0].idcategoriaprogramatica;
    var descripcion = values[0].descripcion;
    var categoriaprogramatica = values[0].categoriaprogramatica;

    blanquear();
    props.onHideAceptaCatProgramatica(
      idcategoriaprogramatica,
      descripcion,
      categoriaprogramatica
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);

    var idcategoriaprogramatica =
      recordsAfterPagingAndSorting()[index].idcategoriaprogramatica;
    var descripcion = recordsAfterPagingAndSorting()[index].descripcion;
    var categoriaprogramatica =
      recordsAfterPagingAndSorting()[index].categoriaprogramatica;

    var datos = [];
    datos.push({
      idcategoriaprogramatica,
      descripcion,
      categoriaprogramatica,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Categorias Programaticas</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell
                      className="py-2 text-center"
                      style={{ width: "100px" }}
                    >
                      {item.categoriaprogramatica}
                    </TableCell>
                    <TableCell
                      className="py-2 text-start"
                      style={{ width: "250px" }}
                    >
                      {item.descripcion}
                    </TableCell>
                    <TableCell
                      className="py-2 text-center"
                      style={{ width: "50px" }}
                    >
                      {item.idcategoriaprogramatica}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarCatProgramatica}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoCatProgramatica;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoCategoriaProgramatica.js